import { IIconProps } from "../types"

export default function IconLR7(props: IIconProps) {
  const width = props.size || props.width || (99 / 5) * 3
  const height = props.size || props.height || (78 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 99 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.734 2.54421C13.5834 1.58452 15.9427 0.704802 18.8817 0.494869C21.8208 0.294933 25.3397 0.774779 28.7586 1.48455C32.1875 2.20432 35.5164 3.15402 39.4851 3.87379C43.4538 4.58356 48.0624 5.0634 53.1507 4.89346C58.2391 4.72351 63.8173 3.90378 67.7561 3.32396C71.6948 2.74415 73.9941 2.40426 76.0234 2.84412C78.0528 3.29397 79.8122 4.51358 81.9015 5.54325C83.9909 6.56292 86.4101 7.38266 88.5094 8.16241C90.5987 8.95216 92.3482 9.70192 93.7777 11.5413C95.1973 13.3807 96.2869 16.3098 97.0067 19.4788C97.7264 22.6478 98.0663 26.0467 97.6765 31.5949C97.2866 37.1531 96.147 44.8606 95.3672 51.0986C94.5975 57.3366 94.1676 62.1051 93.048 65.684C91.9283 69.2628 90.1089 71.6521 87.4098 73.2815C84.7206 74.921 81.1418 75.8107 75.7535 76.3805C70.3552 76.9704 63.1475 77.2403 54.5103 77.3402C45.8831 77.4402 35.8163 77.3702 29.1884 77.1403C22.5505 76.9004 19.3416 76.4905 17.0123 75.7707C14.6731 75.061 13.2235 74.0313 12.1039 72.7417C10.9743 71.4421 10.1945 69.8826 8.22514 63.6446C6.25577 57.4066 3.09679 46.5001 1.61726 39.3124C0.127738 32.1247 0.317677 28.6458 0.797523 25.3369C1.28737 22.038 2.06712 18.899 3.19675 15.63C4.3164 12.3611 5.76593 8.95216 7.16548 6.73287C8.55504 4.51358 9.88461 3.49391 11.734 2.54421Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
